const billingData = require('../jsons/menu/billing.json');
const hiddenData = require('../jsons/menu/hidden.json');
const mapData = require('../jsons/menu/map.json');
const routeData = require('../jsons/menu/route.json');
const searchData = require('../jsons/menu/search.json');
const siteData = require('../jsons/menu/site.json');

const menuRegistry = [
  'site.json',
  'map.json',
  'route.json',
  'search.json',
  'billing.json',
  'hidden.json',
];

const ALL_MENU_DATA = [
  siteData,
  mapData,
  routeData,
  searchData,
  billingData,
  hiddenData,
];

const ALL_MENU_OBJECT_DATA = {
  site: siteData,
  map: mapData,
  route: routeData,
  search: searchData,
  billing: billingData,
  hidden: hiddenData,
};

module.exports = {
  billingData,
  hiddenData,
  mapData,
  routeData,
  searchData,
  siteData,
  menuRegistry,
  ALL_MENU_DATA,
  ALL_MENU_OBJECT_DATA,
};
